// Size filter values can be Search & Discovery group IDs (gid://shopify/FilterSettingGroup/...),
// so find the checkbox by value or by its label (title) and show the label to shoppers.
function rememberSizeInput(size) {
  const escaped = CSS.escape(size);
  return document.querySelector(`[name="filter.v.option.size"][value="${escaped}"], [name="filter.v.option.size"][title="${escaped}"]`);
}

function rememberSizeLabel(size) {
  const input = rememberSizeInput(size);
  return (input && input.title.trim()) || size;
}

class RememberSize {
  constructor() {
    this.page_type = window.page_type;
    this.size = this.getSize();
    this.existingSizes = [];
    this.selectedSizesHidden = this.getCookie('selectedSizesHidden');
    this.currentSizes = new URLSearchParams(window.location.search).getAll('filter.v.option.size');

    if (this.page_type === 'collection') {
      this.collectionPage();
    } else if (this.page_type === 'product') {
      // this.productPage();
    }
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift()
  }

  deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  getSize() {
    const size = sessionStorage.getItem('selectedSizes');
    return size ? JSON.parse(size) : [];
  }

  collectionPage() {
    if (this.size.length > 0 && this.currentSizes.length > 0) {
      const size = this.size.sort().join(',');
      const currentSizes = this.currentSizes.sort().join(',');
      if (size === currentSizes) {
        return;
      }
    }

    this.size.forEach(size => {
      const sizeElement = rememberSizeInput(size);
      if (sizeElement && !this.existingSizes.includes(sizeElement.value)) {
        this.existingSizes.push(sizeElement.value);
      }
    });

    this.setCookie('existingSizes', JSON.stringify(this.existingSizes), 0.1);

    if (this.size?.length && !this.selectedSizesHidden && this.existingSizes?.length) {
      document.querySelector(`remember-size-toggle`).click();
    }
  }

  // productPage() {
  //   if (this.size.length > 0 && !this.selectedSizesHidden) {
  //     const select = document.querySelector('select.productOption');
  //     if (select) {
  //       const options = Array.from(select.options).map(option => option.value);
  //       if (options.length > 0) {
  //         const size = this.size[0];
  //         if (options.includes(size)) {
  //           select.value = size;
  //           select.dispatchEvent(new Event('change'));
  //         } else if (this.size.length > 1) {
  //           const nextSize = this.size.find(size => options.includes(size));
  //           if (nextSize) {
  //             select.value = nextSize;
  //             select.dispatchEvent(new Event('change'));
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}

window.addEventListener('load', () => {
  window.rememberSize = new RememberSize();
});

class RememberSizeClose extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('.remember-size-popup');
    this.body = this.parent.querySelector('[remember-size-body]');
    this.addEventListener('click', this.hideContent.bind(this))
  }

  hideContent() {
    if (this.body) {
      document.body.classList.remove('remember-size-popup-open');
      this.parent.classList.remove('show');
      this.body.innerHTML = ''
    }
  }
}

customElements.define('remember-size-close', RememberSizeClose);

class RememberSizeToggle extends HTMLElement {
  constructor() {
    super();
    this.popup = document.querySelector('.remember-size-popup');
    this.popBody = document.querySelector('[remember-size-body]');
    this.size = this.getSize();
    this.existingSizes = this.getCookie('existingSizes') ? JSON.parse(this.getCookie('existingSizes')) : [];

    this.buildContent();
    this.bindEvents();

    this.showAllButton = undefined;
    this.forgetButton = undefined;
    this.applyButton = undefined;
    this.closeButton = document.querySelector(`remember-size-close`);

    this.addEventListener('click', this.showContent.bind(this));
  }

  buildContent() {
    this.popBody.innerHTML = `
      <div class="remember-size-title">
        We've remembered your
        <span class="remember-size-sizes"></span>
      </div>
      <div class="remember-size-actions">
        <a href="${window.location.href}" class="remember-size-hide button secondary-button d-small-btn">Show me all sizes</a>
        <a href="${window.location.href}" class="remember-size-forget">Forget my size</a>
        <a href="${window.location.href}" class="remember-size-apply button d-small-btn">Browse ${this.existingSizes.length > 0 ? 'size ' : 'sizes '} ${this.existingSizes.join(', ')}</a>
      </div>
    `;
  }

  applySize(event) {
    event.preventDefault();
    const url = new URL(window.location.href);
    this.existingSizes.forEach(size => {
      // check if the size is already in the query
      if (url.searchParams.has('filter.v.option.size')) {
        const sizes = url.searchParams.getAll('filter.v.option.size');
        if (sizes.includes(size)) {
          return;
        }
      }
      url.searchParams.append('filter.v.option.size', size);
    });
    // Collection pages always apply "In stock" with filters; adding it here saves a second page load.
    url.searchParams.delete('filter.v.availability');
    url.searchParams.append('filter.v.availability', '1');

    this.closeButton.click();

    window.location.href = url;
  }

  showAll(event) {
    event.preventDefault();
    this.size = [];
    this.setCookie('selectedSizesHidden', true, 1);
    this.removeCookie('existingSizes');
    sessionStorage.removeItem('selectedSizes');

    const url = new URL(window.location.href);
    url.searchParams.delete('filter.v.option.size');

    window.location.href = url;

    this.closeButton.click();
  }

  forgetSize(event) {
    event.preventDefault();
    this.size = [];
    this.closeButton.click();
    this.removeCookie('existingSizes');
    sessionStorage.removeItem('selectedSizes');

    this.setCookie('selectedSizesHidden', true, 10);
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift()
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  removeCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  bindEvents() {
    this.showAllButton = this.popBody.querySelector('.remember-size-hide');
    this.forgetButton = this.popBody.querySelector('.remember-size-forget');
    this.applyButton = this.popBody.querySelector('.remember-size-apply');

    this.showAllButton.addEventListener('click', this.showAll.bind(this));
    this.forgetButton.addEventListener('click', this.forgetSize.bind(this));
    this.applyButton.addEventListener('click', this.applySize.bind(this));
  }

  getSize() {
    const size = sessionStorage.getItem('selectedSizes');
    return size ? JSON.parse(size) : [];
  }

  showContent() {
    if (this.popup && this.popBody) {
      // RememberSize.collectionPage() writes this cookie on load, after this element was created.
      this.existingSizes = this.getCookie('existingSizes') ? JSON.parse(this.getCookie('existingSizes')) : [];
      const labels = this.existingSizes.map(rememberSizeLabel).join(', ');
      const word = this.existingSizes.length === 1 ? 'size' : 'sizes';

      const sizes = this.popBody.querySelector('.remember-size-sizes');
      sizes.textContent = `${word} ${labels}`;

      const sizesButton = this.popBody.querySelector('.remember-size-apply');
      sizesButton.textContent = `Browse ${word} ${labels}`;

      document.body.classList.add('remember-size-popup-open');
      this.popup.classList.add('show');
    }
  }
}

customElements.define('remember-size-toggle', RememberSizeToggle);